import { Activity, FunctionComponent, memo } from 'react';

import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { Speaker } from '@/types/speakers.types';
import Text from '@ui/text/text/text';

type CustomRenderProps = FunctionComponent<{ option: TReactSelectOption; idx: number; isSelected?: boolean }>;

const RenderMenuOptionContent: CustomRenderProps = memo(({ option }) => {
  const speaker = option.meta as Speaker;
  return (
    <div className="flex ai-center jc-flex-start gap-8 width-100-percent">
      <img
        className="radius-full overflow-hidden image-cover"
        loading="lazy"
        height={24}
        width={24}
        src={speaker.image || undefined}
      />{' '}
      <Text className="S3 flex ai-center jc-flex-start gap-8 fw-nowrap">
        <Text clamp={1} whiteSpace="normal" wordBreak="break-all" design="GlobalIcoText1">
          {`${speaker?.first_name || ''} ${speaker.last_name || ''}`.trim()}
        </Text>
        <Activity mode={speaker?.email ? 'visible' : 'hidden'}>
          <Text design="GlobalIcoText3" className="C1" clamp={1} whiteSpace="normal" wordBreak="break-all">
            {speaker?.email || ''}
          </Text>
        </Activity>
      </Text>
      {/* Commenting out for now, it might come back in if product want it. */}
      {/* <Activity mode={isSelected ? 'visible' : 'hidden'}>
        <Text design="GlobalIcoText1" className="C2 margin-l-auto margin-r-0" whiteSpace="nowrap">
          Already added
        </Text>
      </Activity> */}
    </div>
  );
});

RenderMenuOptionContent.displayName = 'RenderMenuOptionContent';

export default RenderMenuOptionContent;
